import { Fragment } from "react";

import { get_seo } from "../../seo/seoCommon";
import TestAnalyticsUI from "../../../../packages/ui2/components/TestAnalyticsUI";

const TestAnalytics = ({}) => {
    return (
        <Fragment>
            {get_seo("performance_report")}
            <TestAnalyticsUI />
        </Fragment>
    );
};

export async function getStaticProps({ params }) {
    // // Return a list of possible value for id
    // const performance_url = process.env.NEXT_PUBLIC_URL + `/api/performance`;
    // const all_analytics_response = await fetch(performance_url);
    // const all_analytics = await all_analytics_response.json();

    // const all_analytics = await fetch_analytics_list();
    return {
        props: {
            // all_analytics,
        },
        revalidate: 60 * 60 * 24, // revalidate every day or refresh the page when a user submits a test
    };
}

export default TestAnalytics;
